import React, { createContext, useContext, useMemo, useState } from 'react';
import Echo from 'laravel-echo';
import socketio from 'socket.io-client';
import { useAuthDataContext } from './AuthProvider';
import Api from '../__helpers/api';

export const NotificationsContext = createContext({});

const NotificationsListener = props => {

    const auth = useAuthDataContext();

    const [notifications, setNotifications] = useState({
        list: [],
        count: 0,
    })

    // const listener = new Echo({
    //     host: '164.138.220.192:6001',
    //     broadcaster: 'socket.io',
    //     client: socketio,
    //     auth: {
    //         headers: {
    //             Authorization: `Bearer ${auth.user.token}`
    //         },
    //     },
    // });

    // const privateListener = listener.private(`users.${auth.user.id}`);

    const listener = null;
    const privateListener = null;

    const notification = useMemo(() => ({ notifications, listener, privateListener }), [auth]);

    return <NotificationsContext.Provider value={notification} {...props} />;
}

export const useNotificationsContext = () => useContext(NotificationsContext);

export default NotificationsListener;